import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allBlogs: [],
    paginatedBlogs:[],
    categories:["Fiction",
            "Non-Fiction",
            "Mystery",
            "Thriller",
            "Fantasy",
            "Science Fiction",
            "Romance",
            "Historical Fiction",
            "Biography/Autobiography",
            "Self-Help",
            "Young Adult (YA)",
            "Horror",
            "Memoir",
            "Graphic Novels/Comics",
            "Adventure",
            "Poetry",
            "Classics",
            "Dystopian",
            "Children's Literature",
            "True Crime",
            "Trending News",
            "DIY",
            "Occult",
            "Religion"]
}

const blogsSlice = createSlice({
    name: 'blogs',
    initialState,
    reducers: {
        fetchAllBlog: (state, action) => {
            state.allBlogs = action.payload
        },
        fetchAllPaginatedBlogs:(state,action) => {
            state.paginatedBlogs = action.payload
        },
        fetchAllCategories: (state,action) => {
            state.categories = action.payload
        },
        addNewBlog: (state, action) => {
            state.allBlogs.unshift(action.payload.blogs)
        },
        deleteBlog: (state, action) => {
            state.allBlogs = state.allBlogs?.filter(blog => blog.id !== action.payload?.id)
        },
        updateBlog: (state, action) => {
            const updatedBlog = action.payload.blogs;
            const idx = state.allBlogs?.findIndex(blog => blog.id === updatedBlog.id)
            if (idx > -1) {
                state.allBlogs[idx] = updatedBlog;
            }
        }

    }
});

export const blogsAction = blogsSlice.actions;
export default blogsSlice.reducer;